<template>
  <!-- 取得選擇商品料號與 id 彈窗 -->
  <div>
    <button ref="chooseProd" v-show="false" data-toggle="modal" data-target="#searchProd"></button>
    <div class="modal fade" :id="option.id" role="dialog" @click.self="closeModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
            <h4 class="modal-title text-left">{{option.title}}</h4>
          </div>
          <div class="modal-body text-left">
            <div class="text-left">
              <input class="form-control" type="text" v-model="searchText" placeholder="請輸入商品名稱">
              <div class="m-t-15 list-height">
                <div
                  v-for="(item, index) in filterProductList"
                  :key="`item-${index + 1}`"
                  class="form-check"
                >
                  <label class="form-check-label m-y-0" :for="`check${index + 1}`">{{ item.name }} ({{ item.vendor_custom_id }})</label>
                  <input v-model="item.checked" type="checkbox" class="form-check-input" :id="`check${index + 1}`" @change="checkSelect(item)">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal" @click="closeModal">取消</button>
            <button class="btn btn-primary" data-dismiss="modal" @click="selectedProd">
              確定
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: { // 彈窗內容 (含 id, title)
      type: Object,
      required: true
    },
    storeId: Number, // 店家 ID (不傳則抓 router parmas)
    search: String, // 搜尋文字
    openModal: Boolean, // 控制彈窗顯示
    mutiSelect: Boolean // 是否可複選 (預設單選)
  },
  data () {
    return {
      searchText: '', // 搜尋文字
      productInfoList: [] // 商品名稱 + 料號列表
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    store () {
      // get store id
      return this.storeId || this.$route.params.store_id
    },
    filterProductList () {
      // 搜尋篩選
      const result = this.productInfoList.filter((item) => {
        return item.name.toLowerCase().includes(this.searchText.toLowerCase().trim())
      })
      return result
    }
  },
  created () {
    this.getMenuId()
  },
  methods: {
    selectedProd () {
      // 選擇商品
      const selected = this.productInfoList.filter((item) => {
        return item.checked === true
      })
      this.closeModal()
      this.$emit('selectedProd', selected)
      this.clearAll()
    },
    clearAll () {
      // 清空選項
      this.searchText = ''
      this.productInfoList.forEach((item) => {
        item.checked = false
      })
    },
    getMenuId () {
      // 取得該店 Menu id
      const url = 'onlineMenu/list?page=1&size=1&store_id=' + this.store
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const result = response.data.menu_list
            ? response.data.menu_list[0]
              ? response.data.menu_list[0].id
              : null
            : null
          if (result) {
            this.getProductInfoList(result)
          }
        }
      })
    },
    getProductInfoList (menuId) {
      // 取得該店商品列表 (商品名 + 料號)
      const url = 'onlineMenu/' + menuId + '/productBrief'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.productInfoList = []
          const menu = response.data.brief
          menu.category_list.forEach((category) => {
            category.child_list.forEach((prod) => {
              prod.checked = false
              this.productInfoList.push(prod)
            })
          })
        }
      })
    },
    checkSelect (val) {
      if (val && !this.mutiSelect) {
        // 僅能單選
        this.productInfoList.forEach((item) => {
          if (item !== val) {
            item.checked = false
          }
        })
      }
    },
    closeModal () {
      this.$emit('update:openModal', false)
    }
  },
  watch: {
    openModal (val) {
      if (val) {
        this.searchText = this.search || ''
        this.$refs.chooseProd.click()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-check {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #eee;
  &:last-child {
    border-bottom: 0px;
  }
}
.list-height {
  max-height: 50vh;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// ChooseProductModal.vue?dfc87014